module.exports =  {
  TITLE: {
    default: 'ホテル検索/アジアの数万のホテルオンライン予約',
    detail: '|ホテル予約',
  },
  hotel: {
    // 酒店搜索改版新增翻译--日文
    ROOMS: '部屋数',
    GUESTS: '人数',
    CHECK_IN_NUM: '人数',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: '大人',
    SUFFIX_ADULTS: '大人',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: '子供',
    SUFFIX_CHILDREN: '子供',
    CHILD_AGE: 'Child\'s Age',
    NO_MATCH_TIPS: 'The below room type does not match the number of rooms and guests you selected.',

    Book_Hotel: 'ホテル予約',
    Select_your_destination: '目的地をご選択ください',
    Please_enter_your_destination: '目的地/ホテルをご入力ください',
    Booked_up: '既に売り切れました',
    Hotel_description: 'ホテル紹介',
    Check_in_date: 'チェックイン',
    Check_out_date: 'チェックアウト',
    Sold_out: '売り切れ',
    Non_refundable: '取消できません',
    reserve: '予約',
    Pay_Online: 'Pay online',
    Only_rooms_left_before: '',
    Only_rooms_left_after: '客室残り',
    Cancellation_Policy: 'キャンセル規定',
    See_all_prices_before: '全ての',
    See_all_prices_after: 'つ価格を見ます',
    Estimated_time_of_arrival: 'チェックイン予定時間',
    make_your_schedule_well_planned: '地元日時。選択したら、合理的に出行手配します',
    Hotel_Not_Found: '条件に合致するホテルがありません',
    Please_change_your_search: '条件を改めして再びご検索ください',
    Submit_an_application: '申請を提出します',
    Hotel_Confirmation: 'ホテル確認',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '泊泊ります',
    Hotel_Booking_Number: 'ホテル予約番号',
    Online_Payment: 'オンラインペイ',
    The_guest_Room_before: '宿泊代表者様「部屋',
    The_guest_Room_after: '」',
    Contact_number: '電話番号',
    Bring_all_valid_IDs: 'ご宿泊する時、宿泊する人の身分証明書をご提供ください。',
    Hotels_Found_before: '',
    Hotels_Found_after: '軒が見つかりました',
    Hotels_Presented_before: '当前',
    Hotels_Presented_center: 'ヶ所ホテルを示します（合計',
    Hotels_Presented_after: 'ヶ所）',
    Please_change_the_dates: '選択日時の房型がありません、再び宿泊日時をご選択ください',
    Login: '预订酒店需要登录app',
    Nights_in_total_before: '泊数：',
    Nights_in_total_after: '',
    Location: 'ホテル場所',
    Pictures: 'ホテルの写真',
    Description: 'ホテル紹介',
    Policy: 'チェックイン / チェックアウト',
    Check_in_and_check_out_time: '出入り日時',
    Check_in_and_Check_out_before: 'チェックイン開始時刻：',
    Check_in_and_Check_out_center: '以降 チェックアウト時刻：',
    Check_in_and_Check_out_after: '前',
    Check_in_time: 'チェックイン',
    Check_out_time: 'チェックアウト',
    Facility_Service: '施設サービス',
    Payment_methods: 'ホテルが受け取る支払い方法',
    Hotel_Address: '所在地',
    Pay_online: 'オンラインペイ',
    Pay_offline: 'フライン決済',
    Night_stay_before: '',
    Night_stay_after: '泊宿泊し、',
    Rooms_total_before: '客室は合計',
    Rooms_total_after: '元です',
    Guest_name_must_be_provided: '宿泊する人の全名をご記入ください',
    Please_fill_in_your_contact_number: '電話番号をご入力ください',
    Select_estimated_time_of_arrival: '時間を選択',
    Number_of_Rooms: '部屋数',
    Maximum_guests_per_room_before: '1室に最大',
    Maximum_guests_per_room_after: '人宿泊できます',
    Many_Rooms: '客室',
    Service_Fee_Included: '税込みとサービス費',
    Last_Name: '姓 (ローマ字)*',
    First_Name: '姓 (ローマ字)*',
    Room: '客室',
    Additional_Tax: '税金',
    Please_inform_the_hotel: 'もし遅刻する場合、早めにご連絡ください',
    Please_inform_the_hotel_first: '早めにホテルに連絡ありませんため、遅刻する場合、多分部屋と夕食の手配に関係あります。事前にご確認ください',
    Booking_Cancellation: '予約を取消',
    Reason_of_Cancellation: '予約を取消',
    Incorrect_Information_Filled: '情報入力が間違います',
    Itinerary_Changed: '行程が変わります',
    Lower_price_on_other_APP: '他のAPPがもっと安い',
    Low_quality_hotel: 'ホテルはよくない',
    Book_at_a_lower_price: 'カウンターで予約すると、もっと安い',
    Other: '他の',
    Please_write_your_reason: '原因をご入力ください\n',
    After_cancellation_done: '予約取消成功になりましたら、料金は３稼働日以内に返金します',
    How_to_fill_in_the_guest_name: '宿泊人は説明をご入力ください',
    It_should_be_exactly_the_same: 'ホテル予約する時、必ず宿泊人の名前をご入力ください。アルファベットでご入力ください。チェックインする時の証明書と一致しなければなりません',
    How_to_fill_in_a_Chinese_name: '中国名前の入力方法：',
    How_to_fill_in_a_English_name: '英名の入力方法：',
    For_example: '例えば：“韩梅梅”、姓は“Han”、名は“Meimei”',
    No_specical_characters: '英名には数字と特殊文字が含まれません',
    Name_rule_first: '姓は前、名は後。もし中間名がある場合、一字空けて名の後でご入力ください',
    Name_rule_second: '',
    Details: '明細',
    Pay_now: 'すぐ支払',
    Hotel: 'ホテル',
    Check_in: 'チェックイン',
    Car: 'レンタカー',
    All_bookings: '全ての予約',
    All: '全部',
    PROMPT: 'ヒント',

    Search: '検索する',
    COST_DESCRIPTION: '料金について',
    TOTAL: '合計',
    SEE_ORDER_INFO_TO: 'お支払い',
    KONW: '了解',
    BOOKING_INFORMATION: '注意事項',
    Book_Now: 'すぐ支払ます',
    MAP: '地図',
    CONTACT_INFORMATION: '連絡先',
    LOADING: 'ロード中...',
    SORT_FILTER: '並べ替え/選別',
    SCREENING: '検索条件',
    SEQUENCE: '絞り込み検索',
    PHONE_ASK: '電話でお問い合わせ',
    ABOVE: 'より',
    SUBMINT_ORDER: '申込提出',
    OK: 'はい',
    Order_detail: '予約詳細',
    BOOKING_INFO: '予約明細',
    PAYMENT_AMOUNT: '合計料金',
    Order_time: '予約日時',
    ORDER_NUMBERS: '予約番号',
    PAY_TYPE: 'お支払い方法',
    BALANCE: '残高',
    CURRENT_BALANCE_BEGIN: 'バランス',
    OVERPLUS_BALANCE_BEGIN: '残金',
    OTHER_PAYMENT: '他のお支払い方法',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: '「すぐ支払ます」をクリックすれば、本社の',
    AGREE_SERVICE_AGREEMENT_AFTER: 'を同意です',
    SERVICE_AGREEMENT: '《服务协议》',
    PAYMENT_ORDER: '合計料金',
    Total_pay: '請求金額',
    PAY_SUCCESS: '支払成功',
    CHECK_THE_ORDER: '予約をチェックします',
    BACK_TO_INDEX: 'ホームページへ戻す',
    CANCEL: 'いいえ',
    RECOMMED: '人気',
    PRICE: '料金',
    HIGH: '高い',
    LOW: '低い',
    RESET: 'リセット',
    SELECT_TIME: '日付設定',
    Hotel_guest: '宿泊代表者様',
    Select: '選択して下さい',
    Emial_address: 'メールアドレスを入力して下さい',
    Booking_explan: '予約注意事項',
    VIEW_MORE: 'もっと情報を見る',
    COLLAPSE: '閉じる',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'チェックイン',
    TOURISM_LEAVE_HOTEL: 'チェックアウト',
    arrive: '目的地',
    Room_description: '部屋の説明',
    Meals: '食事情報',
    Room_Type: '部屋タイプ',
    BOOKING_EXPLANATION: '予約注意事項',
    BOOKING_BUTTON: '予約',
    REMIND_SUBMIT_ORDER: '申込を続',
    login_now: 'ホテルを予約するにはログインしてください、今すぐログイン？',
    the_real_scene: '写真は参考用です、実際のホテルの滞在を参照してください',
    Bed: 'ベッド',
    Rooms: '部屋',
    Room_rate: '料金',
    notified_by_SMS: 'ご予約後の予約確認メッセージが送信されます',
    email_notifications: 'ご予約後の予約確認メールが送信されます',
    Booking_deadline: '予約受付締切時間',
    Child: 'お子様',
    Additional_notes_about_payment: '料金に関する特記事項',
    Nights: '泊数',
    Minimum_nights_before: '',
    Minimum_nights_after: '泊以上',
    Size: '広さ',
    Guests: '人数',
    Room_rate_1: '税別料金',
    Tax_service_fee: '税/サービス料',
    Pay_now_1: 'すぐ支払',
    Filter: '絞り込み検索',
    Room_rate2: '料金',
    Show_on_map: '地図に表示する',
    Detail: '詳細',
    Room_Detail: '詳細',

    TAXES_INCL: '税込',
    SEARCH_EMPTY_TIP: '申し訳ありませんが、ご選択頂いた日付けの空室なくなりました。日付けもしくはホテルを変えて再検索してください。',
    severalNight: '泊',
    immediateBooking: '今すぐ予約',
    Refundable: 'キャンセルについて',
    MORE: 'もっと',
    adultsCompany: '名大人',
    ServiceTerms: 'サービス・規則',
    roomPlan: 'プラン',
    guestRoom: 'Room',
    searchAgain: '検索する',
    roomNight: '1部屋/1泊',

    NAME_TXT: 'お名前',
    HOLDER_NAME: 'カードに記載された名前',
    EXPIRATION_DATE: '有効期限',
    FORMAT_TXT: 'フォーマット',
    SECURITY_CODE: 'セキュリティコード',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'カードの裏面に記載されている3桁の番号',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: 'カード表面の４桁の数字',
    ENTER_COMPLETE_CARD_NUM: 'カード番号を入力',
    PLEASE_ENTER_HOLDER_NAME: 'カードに記載された名前を入力',
    ENTER_SECURITY_CODE: 'セキュリティコードを入力',
    ENTER_EXPIRATION_DATE: '有効期限を入力',
    ROOM_DETAILS: '客室の詳細',
    CONDITION_CANCEL: 'キャンセルについて',
    CHOOSE_PAYMENT_METHOD: 'お支払い方法の選択',
    ORDER_TOTAL_LUMP: '総額',
    CREDIT_CARD_NUM: 'デビットカード/クレジットカード番号',
    MAINLAND_CARD_ONLY: '中国大陸以外で発行された銀行カードのみ',
    SHUT_DOWN: '閉じる',
    PROVIDER_FROM_CHINA_BANK: '中国銀行よりお支払いのサービスを提供致します',

    COUPON: 'クーポン',
    APPLY_A_COUPON: 'クーポン利用',
    NO_USE: '以下の商品に適用しません',
    Discard: '捨てます',
    REDEEM: '引き換え',
    EMPTY_COUPON: '優待コードを入力して下さい',
    NOTICE_COUPON: '優待券は、1回の予約で一枚のみご利用頂けます。予約申し込みが完了した時点で、優待券が利用されたと認められます。',

    BREAKFAST_INCLUDE: '食付き',
    BREAKFAST_EXCLUDE: '食無し',
    DOUBLE_BED: 'シングルベット',
    TWIN_BED: 'ダブルベット',
    FREE_CANCEL: '無料キャンセル',
    MEALS: '食事',
    EVALUATION: 'コメント',
    FEATURED_REVIEWS: '良いコメント',
    ALL_REVIEWS: '全部コメント',
    OVERALL_EVALUATION: '全体評価',
    ANONYMOUS: '匿名',
    EVAL_GENERAL_LIST_1: '悪い',
    EVAL_GENERAL_LIST_2: '良くない',
    EVAL_GENERAL_LIST_3: '一般',
    EVAL_GENERAL_LIST_4: '良い',
    EVAL_GENERAL_LIST_5: '非常に良い',
    MAX_IMAGES_WITH_NINE: '最大9枚の画像が選びます',
    GRADE_EVAL: '全体評価を選択して下さい',
    DISTANCE_FILTER: '距離　近い→遠い',
    EDIT_EVALUATION: '口コミ投稿',
    GO_TO_EVAL: '口コミ投稿',
    EVAL_POINTS_AWARD: '最大1000ポイントが貯まる（1000ポイント＝CNY10元相当で使える）！',
    NEARBY_LIKE_HOTEL: '周辺の似た条件のホテル',
    DISTANCE_HOTEL: 'アクセス',
    PLEASE_ENTER_COMMENT: '口コミを記入ください',
    AWARD_POINTS_TIPS: '口コミ投稿で最大1000ポイントが貯まる（1000ポイント＝CNY10元相当で使える）！',
    NO_SHOW_ANONYMOUS_AVATAR: '匿名で口コミを記入する場合はユーザーネームとアカウント画像が表示されません',
    LOCATION: 'アクセス',
    FACILITY: '設備',
    SERVICE: 'サービス',
    HEALTH: '清潔度',
    LANGUAGE_SELECT: '表示言語を選択',
    LIMIT_COMMENT_TXT: 'コメントは 5~2000 文字以内にして下さい',
    SHARE_MEDIA: 'ビデオ/写真の共有',
    SETTLEMENT_FEEL: '住む体験',
    SUBMIT_EVAL: '提出',
    HOTEL_STR: '詳細',
    EVAL_NUM_AFTER: '通コメント',
  },
  header: {
    SKIING: 'スキー場',
    header_internal_call: '中国：',
    header_abroad_call: '海外：',
    header_app_download: 'アプリ',
    service_telephone: 'カスタマーサービス',
    account_number: 'アカウント',
    if_bg_user: 'まだBaiGolfのメンバーではない？',
    home: 'ホームページ',
    hotel: 'ホテル',
    Golf: 'ゴルフ',
    PLAY_STAY: 'プレイ + 宿泊',
    RENT_CAR_HOME: 'レンタカー',
    center_user: '会員センター',
    header_my_order: 'Myリクエスト（予約）',
    header_notmember_order: '直接予約',
    header_edit_password: 'パスワードを修正',
    header_logout: 'ログアウト',
    header_login: 'ログイン',
    header_register: '新規登録',
    header_point: 'マイポイント',
    header_all_language: '全ての言語',
    down_load_app: 'QRコードをスキャン，ダウンロード実行',
    login_discount_tip: 'ログイン、ポイントとBaiGolfの特典を獲得'
  },
  footer: {
    footer_partner: 'パートナー',
    footer_about_us: 'BaiGolfについて',
    footer_about_baigolf: 'BaiGolf.comについて',
    footer_privacy_policy: 'BaiGolf.com個人情報保護ポリシー',
    footer_use_of_terms: 'BaiGolf.com利用規約',
    footer_contact_us: 'お問合せ',
    footer_sitemap: 'Sitemap',
    footer_use_of_question: 'Q&A',
    footer_ios_system: 'iOS',
    footer_android_system: 'Android',
    footer_app_load: 'アプリダウンロ',
    footer_sina_weibo: '新浪ミニブログ',
    footer_tencent_weibo: '騰訊ミニブログ',
    footer_share_to: '共有する',
    copyright1: '广州市百高美燚信息技术有限公司 版权所有',
    copyright2: '粤ICP备14070002号',
    news_center: 'ニュースセンター',
    about_baigolf: 'BaiGolfについて',
    help: 'ヘルプ・お問い合わせ',
    management_system: 'BG Golf Management System (BGMS)',
    wechat_official_account: 'WECHAT公式アカウントをフォローし、お得な情報をいち早く入手！',
    download_baiGolf_app: 'アプリ無料ダウンロード',
    privacy_policy: '個人情報保護ポリシー',
    use_of_terms: '利用規約',
    footer_integral: '积分政策',
    footer_reserve: '規約集',
    footer_abroad_call: '海外',
    footer_internal_call: '中国'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ja_jp.js